/**
 * Enum значений GET-параметра `action`, который может быть передан в buttonUrl слайда.
 * Используется для выполнения действий на целевой странице после перехода.
 */
export enum NavigationAction {
    ScrollToFeed = 'scroll_to_feed',
}
